import { FC } from 'react';

const BetaBanner: FC = () => {
  const websiteUrl = 'https://www.caretailor.co.uk';

  return (
    <div className="mt-auto pt-6">
      <div className="flex flex-col items-center justify-center gap-0.5 text-center">
        <p className="text-xs text-gray-400">
          CareTailor . Fixing care starts here
        </p>
        <p className="text-xs text-gray-400">
          Share it. Tell Others. Join the waitlist
        </p>
        <a
          href={websiteUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs text-gray-400 underline hover:text-gray-600"
        >
          www.caretailor.co.uk
        </a>
      </div>
    </div>
  );
};

export default BetaBanner;
